export default {"src":"/_next/static/media/twitter.6f4f51af.svg","height":12,"width":15};